import { HeatmapColorScheme } from '@strava/mre';

import { ColorSchemeString } from '../types';

export const mapColorSchemeStringToMREColorScheme: (
  colorScheme: ColorSchemeString
) => HeatmapColorScheme = (colorScheme) => {
  switch (colorScheme) {
    case 'purple':
      return HeatmapColorScheme.PURPLE;
    case 'bluered':
      return HeatmapColorScheme.BLUE_RED;
    case 'orange':
      return HeatmapColorScheme.ORANGE;
    case 'hot':
      return HeatmapColorScheme.SUNSET;
    case 'gray':
      return HeatmapColorScheme.PINK;
    case 'blue':
    case 'mobileblue':
    default:
      return HeatmapColorScheme.BLUE;
  }
};
